export default "__VITE_ASSET__DA0Sh7p0__"